type orderByType = {
    updatedAt: string
}

export function orderByLastUpdated(a: orderByType, b: orderByType) {
    return new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime()
}
